/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateReportDto } from '../../models/create-report-dto';
import { PickDto } from '../../models/pick-dto';

export interface PickControllerReport$Params {
  id: string;
      body: CreateReportDto
}

export function pickControllerReport(http: HttpClient, rootUrl: string, params: PickControllerReport$Params, context?: HttpContext): Observable<StrictHttpResponse<PickDto>> {
  const rb = new RequestBuilder(rootUrl, pickControllerReport.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PickDto>;
    })
  );
}

pickControllerReport.PATH = '/api/picks/{id}/report';
